<template>
  <div>
    <TitleWrapper
      :filter-option="false"
      title="CHANGE_PASS"
      tooltip-title="CHANGE_PASS"
      :display-breadcrumb="true"
    />
    <div class="bg-primary-white p-3 md:p-7 border rounded-lg border-gray-200">
      <ValidationObserver @submit="changePassword">
        <InputFieldWrapper>
          <InputBox
            v-model.trim="currentPassword"
            type="password"
            name="Current Password"
            title="Current Password"
            label="Current Password"
            rules="min:8|required"
            placeholder="Current Password"
          />
          <InputBox
            v-model.trim="newPassword"
            type="password"
            name="Password"
            title="New Password"
            rules="min:8|required"
            label="New Password"
            placeholder="New Password"
          />
          <InputBox
            v-model.trim="confirmPassword"
            type="password"
            name="Confirm Password"
            title="Confirm Password"
            label="Confirm Password"
            rules="required|confirmed:@Password"
            placeholder="Confirm Password"
          />
        </InputFieldWrapper>
        <UIButton button="primary" :disabled="isLoading">
          <div v-if="isLoading">
            <Loader></Loader>
          </div>
          <div v-else class="px-2">Save Changes</div>
        </UIButton>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import TitleWrapper from '@components/TitleWrapper.vue'
import AuthMixins from '@src/mixins/auth-mixin.js'
import UIButton from '@src/components/UiElements/UIButton.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import { mapState, mapActions } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import { Form as ValidationObserver } from 'vee-validate'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    TitleWrapper,
    UIButton,
    Loader,
    InputFieldWrapper,
    ValidationObserver,
    InputBox,
  },
  mixins: [AuthMixins],
  data() {
    return {
      isLoading: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    }
  },
  methods: {
    async changePassword() {
      this.isLoading = true
      let payload = {
        current_password: this.currentPassword,
        updated_password: this.newPassword,
        confirmed_password: this.confirmPassword,
      }

      this.updateUserPassword(payload)
        .then(() => {
          this.resetData()
          this.signOut()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    resetData() {
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
    },
    ...mapActions('institute', ['updateUserPassword']),
  },
}
</script>
